const LangMyTransactions = {
	"myTransactions._title": ["MY TRANSACTIONS", "ប្រតិបត្តិ​ការ​​ខ្ញុំ"],
	"myTransactions.header._transactions": ["TRANSACTIONS", "ប្រតិបត្តិ​ការ​"],
	"myTransactions.header._amount": ["AMOUNT", "ចំនួនទឹក​ប្រាក់"],
	"myTransactions.header._starEarned": ["STAR EARNED", "ចំនួន​ផ្កាយ​"],
	"myTransactions.header._datetime": ["DATE TIME", "កាល​បរិចេ្ឆទ​ ម៉ោង​"],
	"myTransactions.header._outlet": ["STORE", "សាខា​"],
	"myTransactions.body._noAvailableRecord": [
		"There are no transactions at the moment",
		"ខណៈ​នេះ​ ពុំ​ទាន់​មាន​ប្រតិបត្តិការ​ទេ​",
	],
	"myTransactions.type.SALES": [
		"Mobile Ordering & Payment Purchase",
		"ទិញ​នៅ​​តាម​សាខា​",
	],
	"myTransactions.type.PLUS ADJUSTMENT": [
		"In Store Reload",
		"បញ្ចូល​ទឹក​ប្រាក់​នៅ​​​តាម​សាខា",
	],
	"myTransactions.type.CUSTOMER CARE": [
		"Customer Care Center",
		"ផ្នែក​បម្រើ​សេវា​អតិថិជន",
	],
	"myTransactions.type.FUNDS TRANSFER": ["Funds Transfer", "ការ​ផ្ទេរ​ទឹក​ប្រាក់​"],
	"myTransactions.type.MINUS ADJUSTMENT": ["MINUS ADJUSTMENT", "vi_MINUS ADJUSTMENT"],
	"myTransactions.type.POINTS REDEMPTION": [
		"POINTS REDEMPTION",
		"vi_POINTS REDEMPTION",
	],
	"myTransactions.type.REFUND SALES ITEMS": [
		"REFUND SALES ITEMS",
		"vi_REFUND SALES ITEMS",
	],
	"myTransactions.type.POINTS REWARD FOR ITEM": [
		"POINTS REWARD FOR ITEM",
		"vi_POINTS REWARD FOR ITEM",
	],
	"myTransactions.type.ITEM REDEMPTION": ["ITEM REDEMPTION", "vi_ITEM REDEMPTION"],
	"myTransactions.type.VOUCHER REDEMPTION": [
		"Mobile Order Rewards Redemption",
		"ការ​ប្តូរ​រង្វាន់",
	],
	"myTransactions.type.IAD SALES": ["Starbucks Delivers Purchase", "ការ​ប្តូរ​រង្វាន់"],
	"myTransactions.type.IAD SALES REDEMPTION": [
		"Starbucks Delivers Rewards Redemption",
		"ការ​ប្តូរ​រង្វាន់",
	],
	"myTransactions.type.MOBILE RELOAD": ["Mobile Reload", "ការ​ប្តូរ​រង្វាន់"],
	"myTransactions.type.AUTO RELOAD": ["Auto Reload", "ការ​ប្តូរ​រង្វាន់"],
	"myTransactions.type.PORTAL RELOAD": ["Portal Reload", "ការ​ប្តូរ​រង្វាន់"],
	"myTransactions.type.IN STORE PURCHASE": ["In Store Purchase", "ការ​ប្តូរ​រង្វាន់"],
	"myTransactions._details": ["Details", "លម្អិត​"],
}

export default LangMyTransactions



// WEBPACK FOOTER //
// ./src/resources/modules/LangMyTransactions.js